import React from 'react';
import { Link } from 'react-router-dom';
import { Plane, Hotel, FileSignature, CheckCircle } from 'lucide-react';
import { planFromHome } from '@/components/seo/districtI18n';
import { toSitePath } from '@/lib/siteDomain';

const STEP_ICONS = [Plane, Hotel, FileSignature, CheckCircle];

// "Plan your trip to Portugal from home" block — targets international tourists
// who are still in their country researching and organising their trip. Rendered
// on district landing pages so searchers abroad find us during trip planning.
export default function PlanFromHomeSection({ lang, district }) {
  const c = planFromHome(lang, district);
  if (!c) return null;
  const startPath = (typeof window !== 'undefined' && window.location.hostname.includes('gestosageis')) ? '/gestosageis' : '/start';

  return (
    <section className="bg-gradient-to-br from-[#0a3452]/5 to-white border border-[#0a3452]/15 rounded-2xl p-6 md:p-8 my-10">
      <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-3">{c.heading}</h2>
      <p className="text-slate-700 leading-relaxed text-lg mb-6 max-w-3xl">{c.text}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {c.steps.map((s, i) => {
          const Icon = STEP_ICONS[i] || CheckCircle;
          return (
            <div key={i} className="bg-white border border-slate-200 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-7 h-7 rounded-full bg-[#0a3452] text-white text-sm font-bold flex items-center justify-center shrink-0">{i + 1}</span>
                <Icon className="w-5 h-5 text-[#0a3452] shrink-0" />
              </div>
              <p className="font-semibold text-slate-800 text-sm leading-snug">{s.t}</p>
              <p className="text-xs text-slate-500 mt-1 leading-relaxed">{s.d}</p>
            </div>
          );
        })}
      </div>
      <Link
        to={toSitePath(startPath)}
        className="inline-flex items-center gap-2 bg-[#0a3452] hover:bg-[#0a3452]/90 text-white font-semibold px-6 py-3 rounded-xl transition-colors"
      >
        {c.cta}
        <Plane className="w-4 h-4" />
      </Link>
    </section>
  );
}